export default __webpack_public_path__ + "static/media/defichain-dex-swap.fb8636ba.svg";